import { map, uniqBy } from 'lodash-es';

export const getUniqueSizesFromImages = (images) =>
  map(uniqBy(images, 'size.id'), 'size');

export const getUniqueFormatsFromImages = (images) =>
  map(uniqBy(images, 'format'), 'format');

export const getUniqueResolutionsFromImages = (images) =>
  map(uniqBy(images, 'resolution'), 'resolution');

export const getImagesBySize = (images, size) => {
  return images.filter((image) => image.size.id === size.id);
};

export const getImagesByFormat = (images, format) => {
  return images.filter((image) => image.format === format);
};

export const getImagesByResolution = (images, resolution) => {
  return images.filter((image) => image.resolution === resolution);
};

export default {
  getUniqueSizesFromImages,
  getUniqueFormatsFromImages,
  getUniqueResolutionsFromImages,
  getImagesBySize,
  getImagesByFormat,
  getImagesByResolution
};
